import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../Button';

import { PROFILE, COMMON } from '../../../constants/strings';

const CLOSE_BUTTON_WIDTH = 168;

const EmailConfirmation = ({
  email,
  showClose,
  onClose,
  style,
  formatMessage,
}) => (
  <section style={style}>
    <div>{formatMessage(PROFILE.edit.emailConfirmationText, { email })}</div>
    <If condition={showClose}>
      <Button
        className="mt3 mr2"
        style={{ width: CLOSE_BUTTON_WIDTH }}
        raised
        color="primary"
        onClick={onClose}
      >
        {formatMessage(COMMON.close)}
      </Button>
    </If>
  </section>
);

EmailConfirmation.propTypes = {
  email: PropTypes.string.isRequired,
  showClose: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  style: PropTypes.object,
  formatMessage: PropTypes.func,
};

export default EmailConfirmation;



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/EmailConfirmation/index.jsx